import { render, staticRenderFns } from "./motivoConsultaShow.vue?vue&type=template&id=36f0d730&"
import script from "./motivoConsultaShow.vue?vue&type=script&lang=js&"
export * from "./motivoConsultaShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports